import React from 'react';
import { GuestWedding } from '../GuestWeddingTypes';
import { EIPSection } from './EIPSection';
import { QuestionsComponent } from './EIPQuestionComponent';

interface Props {
  guestWedding?: GuestWedding;
}

export const GeneralQuestions: React.FC<Props> = ({ guestWedding }) => {
  const questions = guestWedding?.questions || [];
  const description = (
    <>
      These questions will be asked of all guests that RSVP, regardless of if they say &apos;Yes&apos; or &apos;No&apos;
    </>
  );

  return (
    <div data-testid="general-questions">
      <EIPSection title="General Questions" description={description}>
        <QuestionsComponent questions={questions} />
      </EIPSection>
    </div>
  );
};
